import { PurpleButton } from "../buttons/purpleButton";
import { SearchBarContainer } from "./styles";

interface SearchBarProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onClick: () => void;
}

export const SearchBar = ({
  value,
  placeholder = "Pesquisar",
  onChange,
  onClick,
}: SearchBarProps) => {
  return (
    <SearchBarContainer
      onSubmit={(event) => {
        event.preventDefault();
        onClick();
      }}
    >
      <input
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      <PurpleButton title="Pesquisar" submit />
    </SearchBarContainer>
  );
};
